import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {sendJson} from '../Helpers/Helpers';

import './Remarks.css';

class Remarks extends Component {
	constructor(props) {
		super(props);

		this.state = {
			value: '',
			remarks: props.remarks || '',
			isActive: false,
			isSending: false,
			isOnline: true,
			disabled: props.disabled || false,
			hasEndpoint: props.endpoint || false
		}
	}
	static getDerivedStateFromProps(props, state) {
		if (!state.remarks && props.remarks) {
			return {
				remarks: props.remarks
			}
		}
		return null
	}
	componentDidMount() {
		this._mounted = true;
		window.addEventListener('online', this.handleOnlineEvent.bind(this));
		window.addEventListener('offline', this.handleOnlineEvent.bind(this));
	}
	componentWillUnmount() {
		this._mounted = false;
		window.removeEventListener('online', this.handleOnlineEvent);
		window.removeEventListener('offline', this.handleOnlineEvent);
	}
	handleOnlineEvent(event) {
		if (this._mounted) {
			this.setState({isOnline: (event.type === 'online')});
		}
	}
	handleClick() {
		this.setState({isActive: true}, () => {
			this.textInput.focus();
		});
	}
	handleKeyPress(event) {
		// Make sure the form doesn't get submitted when pressing enter
		if (event.key === 'Enter') {
			event.preventDefault();
			this.handleBlur(event);
		}
	}
	handleChange(event) {
		const { value } = event.target
		this.setState({ value });
	}
	handleBlur(event) {
		const { value } = event.target;
		if (value) {
			if (this.state.hasEndpoint) {
				this.setState({ isSending: true }, () => {
					sendJson({'remark_text': value}, this.props.endpoint)
						.then(response => {
							this.setState({
								value: '',
								remarks: response.data ? response.data.remark_text : '',
								isActive: false,
								isSending: false
							});
						}).catch(console.error) // @todo Should show user friendly message
				});
			} else {
				this.setState({
					remarks: value + '\n' + this.state.remarks,
					isActive: false
				}, () => {
					// Make sure the value is cleared after it has been set to the remarks value
					this.setState({ value: '' });
				});
			}
		} else {
			this.setState({ isActive: false });
		}
	}
	render() {
		return (
			<div className={`remarks ${this.state.isOnline ? '' : 'disabled'} ${this.state.isActive ? 'active' : ''} ${this.state.isSending ? 'sending' : ''}`}
				onClick={this.handleClick.bind(this)}
				onBlur={this.handleBlur.bind(this)} >
				<input type="text"
					ref={(input) => { this.textInput = input; }}
					onKeyPress={this.handleKeyPress.bind(this)}
					disabled={this.state.isSending || !this.state.isOnline}
					hidden={!this.state.isOnline}
					value={this.state.value}
					data-notrequired={this.props['data-notrequired']}
					onChange={this.handleChange.bind(this)} />
				<textarea
					disabled
					value={this.state.remarks}
					name={this.props.name}
					data-notrequired={this.props['data-notrequired']} />
			</div>
		);
	}
}

Remarks.propTypes = {
	remarks: PropTypes.string
}

export default Remarks;
